import { defaultAgent, apiResponse, uploadToGoogle } from '../helpers/web-agent';
import { getPostFileUploadURL } from '../constants/utils';
import { toastError } from './toast';
import { tokenExpired } from './auth';
import {
	GET_USER_SETTINGS, REFRESH_SETTINGS, LEFT_SIDE_MENU_TOGGLE, GET_USER_CONFIGURATION,
	POST_FILE_UPLOADING, POST_FILE_UPLOAD_ON_SUCCESS, POST_FILE_UPLOAD_ON_FAILTURE, CLEAR_POST_FILE_UPLOAD,
	GET_USER_FARM_CONFIGURATION, GET_USER_FARM_CONFIGURATION_REQUEST
} from '../constants/action-types';
import { USER_SETTINGS_UPDATED, USER_CONFIGURATION_UPDATED } from '../constants/messages';
import { FILE_STORAGE_GOOGLE } from '../constants';
import { getDuration } from './chat';


export const settings = data => ({ type: GET_USER_SETTINGS, payload: data });

export const refreshSettings = () => ({ type: REFRESH_SETTINGS });

export const leftSideToggle = () => ({ type: LEFT_SIDE_MENU_TOGGLE });

export const userConfiguration = (name, data) => ({ type: GET_USER_CONFIGURATION, name, payload: data });

export const userFarmConfiguration = data => ({ type: GET_USER_FARM_CONFIGURATION, payload: data });

export const userFarmConfigurationRequest = () => ({ type: GET_USER_FARM_CONFIGURATION_REQUEST });


// Post image upload
export const fileUploadInProgress = payload => ({ type: POST_FILE_UPLOADING, payload });

export const fileUploadedOnSuccess = payload => ({ type: POST_FILE_UPLOAD_ON_SUCCESS, payload });

export const fileUploadOnFailure = payload => ({ type: POST_FILE_UPLOAD_ON_FAILTURE, payload });

export const clearfileUpload = () => ({ type: CLEAR_POST_FILE_UPLOAD });

export const getSettings = (cb) => dispatch => {
	defaultAgent.get('/api/user/settings', null, { requestId: "userSettings" }).then(res => {
		const agentResult = apiResponse(res, []);
		if (agentResult.isUnauthorized) {
			dispatch(toastError(agentResult.message));
			dispatch(tokenExpired());
			if (cb) cb();
		} else if (agentResult.data) {
			dispatch(settings(agentResult.data));
			if (cb) cb();
		}
		else if (agentResult.message) {
			dispatch(toastError(agentResult.message));
			dispatch(settings());
			if (cb) cb();
		}
	}).catch(ex => {
		if (defaultAgent.isCancel(ex)) return console.log(`Get user settings: `, ex.message);
		dispatch(toastError(ex.message));
		dispatch(settings());
	});
};

export const updateSettings = params => dispatch => {
	defaultAgent.put('/api/user/settings/update', params).then(res => {
		const agentResult = apiResponse(res, []);
		if (agentResult.isUnauthorized) {
			dispatch(toastError(agentResult.message));
			dispatch(tokenExpired());
		} else if (agentResult.code === USER_SETTINGS_UPDATED.code)
			dispatch(getSettings());
		else if (agentResult.message)
			dispatch(toastError(agentResult.message));
	}).catch(ex => {
		dispatch(toastError(ex.message));
	});
};

export const updateConfiguration = (params, cb) => dispatch => {
	defaultAgent.put('/api/user/configuration', params, { requestId: "user_configuration" }).then(res => {
		const agentResult = apiResponse(res, []);
		if (agentResult.isUnauthorized) {
			dispatch(toastError(agentResult.message));
			dispatch(tokenExpired());
			if (cb) cb(false);
		} else if (agentResult.code === USER_CONFIGURATION_UPDATED.code) {
			if (cb) cb(true);
		} else if (agentResult.message) {
			dispatch(toastError(agentResult.message));
			if (cb) cb(false);
		}
	}).catch(ex => {
		if (defaultAgent.isCancel(ex)) return console.log(`Get user configuration: `, ex.message);
		dispatch(toastError(ex.message));
		if (cb) cb(false);
	});
};

export const getUserConfiguration = (name, params) => dispatch => {
	defaultAgent.get('/api/user/configuration', params).then(res => {
		const agentResult = apiResponse(res, []);
		if (agentResult.isUnauthorized) {
			dispatch(toastError(agentResult.message));
			dispatch(tokenExpired());
		} else if (agentResult.data) {
			dispatch(userConfiguration(name, agentResult.data));
		} else if (agentResult.message) {
			dispatch(toastError(agentResult.message));
		}
	}).catch(ex => {
		dispatch(toastError(ex.message));
	});
};


export const uploadPostFile = (attachment) => {

	const uploadUrl = `${getPostFileUploadURL()}posts/`;

	return dispatch => {
		if (attachment.storage === FILE_STORAGE_GOOGLE) {

			const handleProcessing = params => dispatch(fileUploadInProgress(params));
			uploadToGoogle({ attachment, uploadUrl }, handleProcessing).then(res => {
				if (res.status === 200) {
					const url = attachment.name;
					if (attachment.file.type.indexOf("audio") >= 0 || attachment.file.type.indexOf("video") >= 0)
						getDuration(url, duration => {
							dispatch(fileUploadedOnSuccess({ url, duration }))
						});
					else
						dispatch(fileUploadedOnSuccess({ url }));
				}
				else {
					dispatch(fileUploadOnFailure());
					dispatch(toastError("Failed to share"));
				}
			}).catch(ex => {
				dispatch(fileUploadOnFailure());
				dispatch(toastError(ex.message));
			});
		}
	};
}

export const getUserFarmConfiguration = (params) => dispatch => {
	dispatch(userFarmConfigurationRequest())
	defaultAgent.get(`/api/user/farm/configuration?farm_uuid=${params.farmId}`).then(res => {
		const agentResult = apiResponse(res, []);
		if (agentResult.isUnauthorized) {
			dispatch(toastError(agentResult.message));
			dispatch(tokenExpired());
		} else if (agentResult.data) {
			dispatch(userFarmConfiguration(agentResult.data));
		} else if (agentResult.message) {
			dispatch(toastError(agentResult.message));
		}
	}).catch(ex => {
		dispatch(toastError(ex.message));
	});
};

export const saveUserFarmConfiguration = (params, cb) => (dispatch) => {
	defaultAgent.post(`/api/user/farm/configuration`, params)
		.then(res => {
			const agentResult = apiResponse(res, []);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
				if (cb) cb(false);
			}
			else if (agentResult.code === 2079) {
				dispatch(toastError(agentResult.message));
				if (cb) cb(false);
			} else if (agentResult.code === 2078) {
				if (cb) cb(true);
			}
		}).catch(ex => {
			dispatch(toastError(ex.message));
		});
};